export const pascalToSentenceCase = (str) => {
  return (
    str
      // Split at capital letters
      .split(/(?=[A-Z])/)
      // Join with spaces and convert to lowercase
      .join(" ")
      // Capitalize first letter
      .charAt(0)
      .toUpperCase() +
    // Add rest of the string
    str
      .split(/(?=[A-Z])/)
      .join(" ")
      .slice(1)
      .toLowerCase()
  );
};

export const snakeToSentence = (str) => {
  return str
    .toLowerCase() // Convert the string to lowercase
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
};
export const maskId = (id) => {
  const encodedId = String(id) + "<";
  return encodeURIComponent(encodedId);
};

export const unmaskId = (maskedId) => {
  try {
    const decodedId = decodeURIComponent(maskedId);
    return decodedId.slice(0, decodedId.length - 1);
  } catch (error) {
    console.error("Error decoding or unmasking ID:", error);
    return null;
  }
};